import axios from '@axios'
import store from '@/store'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {

    // linguagem
    setLanguage(context, data) {
      return new Promise((resolve, reject) => {
        axios.post('usuario-configuracao/idioma', data)
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },

    // landingpage
    getConfigLandingpage() {
      return new Promise((resolve, reject) => {
        axios.get('usuario-configuracao/landing-page')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    setConfigLandingpage(context, data) {
      return new Promise((resolve, reject) => {
        axios.post('usuario-configuracao/landing-page', data)
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },

    getIndicacao() {
      return axios.get('/indicacao')
    },

    // tela
    getConfigTela() {
      return new Promise((resolve, reject) => {
        axios.get('usuario-configuracao/tela')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    setConfigTela(context, data) {
      return new Promise((resolve, reject) => {
        axios.post('usuario-configuracao/tela', data)
          .then(response => {
            store.commit('appConfig/UPDATE_SKIN', data.modoTela)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },

    // Exchange API - Genérico
    getExchangeConfig() {
      return new Promise((resolve, reject) => {
        axios.get('usuario-configuracao/corretora-api')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    setExchangeConfig(context, data) {
      return new Promise((resolve, reject) => {
        axios.post('usuario-configuracao/corretora-api', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    deleteExchangeConfig(context, { corretoraId }) {
      return new Promise((resolve, reject) => {
        axios.delete(`usuario-configuracao/corretora-api/${corretoraId}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    // Futures - position mode
    getModoPosicaoHedge() {
      return new Promise((resolve, reject) => {
        axios.get('fut/usuario-info/modo-posicao-hedge')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    setModoPosicaoHedge(context, data) {
      return new Promise((resolve, reject) => {
        axios.post('fut/usuario-info/modo-posicao-hedge', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    // API Info - Informações detalhadas da API
    getApiInfo(context, { corretoraId }) {
      return new Promise((resolve, reject) => {
        axios.get('/usuario-info/api/info', {
          params: { corretoraId },
        })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    // notificacoes
    getConfigNotificacao() {
      return new Promise((resolve, reject) => {
        axios.get('usuario-configuracao/notificacao')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    setConfigNotificacao(context, data) {
      return new Promise((resolve, reject) => {
        axios.post('usuario-configuracao/notificacao', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    telegramNotificacaoEnvioTeste() {
      return new Promise((resolve, reject) => {
        axios.get('healthcheck/telegram-notificacao')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    // senhas
    alterarSenha(context, data) {
      return new Promise((resolve, reject) => {
        axios.post('usuario-configuracao/alterar-senha', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    recuperarSenha(context, data) {
      return new Promise((resolve, reject) => {
        axios.post('usuario-configuracao/recuperar-senha', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    trocarSenha(context, data) {
      return new Promise((resolve, reject) => {
        axios.post('usuario-configuracao/trocar-senha', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

  },
}
